import * as React from "react";
import { forwardRef } from "react";
const SvgTriangle = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 25, viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M11.344 6.07781C11.6296 5.56258 12.3704 5.56259 12.656 6.07781L18.7699 17.1086C19.0469 17.6085 18.6854 18.2222 18.1139 18.2222H5.88612C5.31459 18.2222 4.95308 17.6085 5.23014 17.1086L11.344 6.07781Z", stroke: "#2B2B35", strokeWidth: 1.5 }));
const ForwardRef = forwardRef(SvgTriangle);
export { ForwardRef as ReactComponent };
